// extracted by mini-css-extract-plugin
export default {"login":"Login_login__3cJrA","create_account":"Login_create_account__2wliv"};